// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'

import MainLobby        from '../components/MainLobby.vue'
import StarredPage      from '../components/StarredPage.vue'
import WishesPage       from '../components/WishesPage.vue'
import CustomersPage    from '../components/CustomersPage.vue'
import CustomerDetail   from '../components/CustomerDetail.vue'
import TagManagement    from '../components/TagManagement.vue'
import CompaniesPage    from '../components/CompaniesPage.vue'
import CompanyDetail    from '../components/CompanyDetail.vue'
import EstimatesPage    from '../components/EstimatesPage.vue'
import InventoryPage    from '../components/InventoryPage.vue'

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: MainLobby,
    props: () => ({ username: localStorage.getItem('username') })
  },
  {
    path: '/inventory',
    name: 'Inventory',
    component: InventoryPage
  },
  {
    path: '/starred',
    name: 'Starred',
    component: StarredPage,
    props: () => ({ username: localStorage.getItem('username') })
  },
  {
    path: '/wishes',
    name: 'Wishes',
    component: WishesPage,
    props: () => ({ username: localStorage.getItem('username') })
  },
  {
    path: '/customers',
    name: 'Contacts',
    component: CustomersPage,
    props: () => ({ username: localStorage.getItem('username') })
  },
  {
    path: '/customers/:id',
    name: 'CustomerDetail',
    component: CustomerDetail,
    props: true
  },
  {
    path: '/tags',
    name: 'Tags',
    component: TagManagement
  },
  {
    path: '/companies',
    name: 'Companies',
    component: CompaniesPage
  },
  {
    // Query param — company names often contain "/" which Apache rejects in the path
    path: '/companies/view',
    name: 'CompanyDetail',
    component: CompanyDetail,
    props: (route) => ({ company: route.query.name || '' })
  },
  {
    path: '/estimates',
    name: 'Estimates',
    component: EstimatesPage,
    props: () => ({ username: localStorage.getItem('username') })
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/'
  }
]

export default createRouter({
  history: createWebHistory(),
  routes
})